module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/foreword"
    }
  }, [_c('em', [_vm._v("Author’s foreword")])])]), _vm._v(" "), _c('div', {
    staticClass: "lb-db"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01"
    }
  }, [_c('strong', [_vm._v("GETTING STARTED")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec1"
    }
  }, [_vm._v("Range of pests and diseases")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec2"
    }
  }, [_vm._v("Prevention and control")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec3"
    }
  }, [_vm._v("Biological controls")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec4"
    }
  }, [_vm._v("Using pesticides and fungicides")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0001-01.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "org-dorg"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("ORNAMENTAL PLANTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Border flowers and bedding plants")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ornamental trees and shrubs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plants in containers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Water-garden plants")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rock-garden plants")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lawns")])])]), _vm._v(" "), _c('div', {
    staticClass: "gr-dgr"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("HERBS, FRUITS AND VEGETABLES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Culinary herbs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soft fruits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tree fruits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prevention and control for fruits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vegetables")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0001-02.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "vio-dvio"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("INDOOR PLANTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plants in homes and greenhouses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Orchids")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cacti and other succulents")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0001-03.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Checklist for “green” solutions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/glossary",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Glossary")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef6128c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 60
// module chunks = 0